import * as Types from './../../mutationTypes'

export default {
    [Types.SET_CITIZENSHIPS](state, data) {
        state.module = data
    }
}